const state = {
  devices_where_changed_by_ws: false,
  show_tag_filter: false,
  search_by_string: '',
  device_list: [],
  desktop_list: [],
  desktops_cache: [],
  device_desktop_groups: [],
  desktops_selected_left: [],
  desktops_selected_right: [],
  desktop_groups_selected_right: [],
  device_tags: [],
  device_tags_unused: [],
  content_downloads: [],
  desktops_affected: [],
  desktops_component_right: 'devices',
  devices_reloading: false,
  device_filter: {
    left: {
      deviceTags: [],
      deviceTagsAll: false,
      deviceTypes: []
    },
    right: {
      deviceTags: [],
      deviceTagsAll: false,
      deviceTypes: []
    }
  },
  pagination: {
    left: {
      offset: 0,
      limit: 10,
      page: 1
    },
    right: {
      offset: 0,
      limit: 10,
      page: 1
    }
  },
  pagination_groups: {
    left: {
      offset: 0,
      limit: 10,
      page: 1
    },
    right: {
      offset: 0,
      limit: 10,
      page: 1
    }
  },
  localStatusDeviceFilters: {
    left: [],
    right: []
  }
}

export default state



//////////////////
// WEBPACK FOOTER
// ./state/device/device.state.js
// module id = null
// module chunks = 